import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledUpdateForm = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${props => props.theme.layout('1.5sp')};
  padding: ${props => props.theme.spacing(2)} ${props => props.theme.spacing(3)};
  border-top: ${props => props.theme.layout(1)} solid ${props => props.theme.property('palette.divider')};
  background-color: ${props => props.theme.property('palette.background.paper')};

  .UpdateForm {
    &-form {
      width: 1px;
      flex-grow: 1;

      .Form-fields {
        .FormControl {
          flex-grow: 1;
        }
      }
    }
    
    &-icons {
      display: flex;
      align-items: center;
      column-gap: ${props => props.theme.layout('1sp')};
    }
  }

  &.UpdateForm-timeline {
    .Form-fields {
      .FormControl {
        .InputContainer {
          overflow: visible;
          
          .MuiInputBase-root {
            margin: 0;
            padding: 0;

            > .EditorInput, > .MentionsInput, > textarea {
              margin: 0;
              width: 100%;
              height: 100%;
            }

            > .EditorInput .ProseMirror, > .MentionsInput > * > div, textarea, textarea {
              padding: 0;
              scroll-padding: 0;
            }

            .EditorMenu {
              width: 100%;
              left: 0;
              bottom: ${props => props.theme.layout(-2.5)};
              padding: ${props => props.theme.spacing(0.5)} 0 0 0;
            }

            .EditorInput, .MentionsInput > * > div, textarea {
              min-height: ${props => props.theme.layout(24)};

              &.EditorInput-showMenu {
                min-height: ${props => props.theme.layout(3 * 24 + 38)};
              }
            }
          }
        }
      }
    }
  }
  
  &.UpdateForm-simple {
    padding: ${props => props.theme.spacing(2)};
    background-color: ${props => props.theme.property('palette.primary.states.hover')};
    
    .Form-fields {
      .FormControl {
        .MuiInputBase-root {
          background-color: ${props => props.theme.property('palette.background.paper')};

          .MuiInputAdornment-positionEnd {
            align-items: center;

            .IconButton {
              &:not(${props => props.theme.state2Selector('IconButton', null, ['disabled'], '')}) {
                ${props => props.theme.state2Selector('IconButton', null, ['hover', 'focus', 'focusVisible'])} {
                  background-color: unset !important;

                  .Icon {
                    color: ${props => props.theme.property('palette.primary.main')};
                  }
                }
              }
            }
          }

          .EditorMenu {
            width: calc(100% - ${props => props.theme.layout('4.5sp')});
            bottom: ${props => props.theme.layout(1.5)};
            left: ${props => props.theme.layout(1)};
          }
        }
      }
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    padding: ${props => props.theme.spacing(2)};
  }
    
  ${ComponentStyles}
`;

StyledUpdateForm.propTypes = {
  theme: PropTypes.object
};

export default StyledUpdateForm;
